module.exports = __webpack_public_path__ + "static/media/20210409_212755_405_IMG_0225.a069093a.jpg";